type UserScope = Record<string, string | string[] | Record<string, string>>

export let userScope: UserScope
export const setUserScope = (scope: string) => {
  if (scope) {
    userScope = JSON.parse(scope)
    sessionStorage.setItem('userScope', scope)
  }
}

function getUserScope(): UserScope {
  if (userScope) {
    return userScope
  }

  try {
    userScope = JSON.parse(sessionStorage.getItem('userScope') ?? '')
    return userScope
  } catch {
    return {}
  }
}

export default getUserScope
